$(document).on("admin-tribes-index:ready", function () {
  const form = $("#tribes-filter-sort-pagination-form");
  const loadingIndicator = $("#loading-indicator"); // Assuming this ID is added to HAML
  if (form.length === 0) return;

  // Initialize Select2 for filter dropdowns
  $("#state-filter").select2({
    placeholder: "Filter by State(s)",
    // allowClear: true // Optional: to allow clearing selection
  });
  $("#editor-filter").select2({
    placeholder: "Filter by Editor(s)",
    // allowClear: true // Optional
  });

  const showLoading = () => {
    if (loadingIndicator.length) loadingIndicator.show();
  };

  // Hide loading on initial full page load (after Turbolinks/Turbo potentially)
  // $(window).on('load', function() { // 'load' might be too late if using Turbolinks
  //   if (loadingIndicator.length) loadingIndicator.hide();
  // });
  // For Turbolinks/Turbo, it's often better to ensure it's hidden by default via CSS
  // and only shown right before a form submission that causes a full reload.

  form.on("submit", function () {
    showLoading();
  });

  // 'Show X entries' dropdown change
  $("#per-page-select").on("change", function () {
    // Reset page to 1 when per_page changes, then submit
    form.find("#tribe-page-field").val(1);
    // showLoading(); // Form submit event will handle this
    form.submit();
  });

  // Pagination links click (using class .pagination-link added in HAML)
  // Note: Rails UJS might handle these links already if they are standard GET requests.
  // This JS is a fallback or can be used to explicitly control via form submission if UJS isn't active or if more complex logic is needed.
  // For simple GET links as generated, this JS might not be strictly necessary, but added for completeness of control.
  // Pagination links: If they are standard GET links, the browser handles navigation.
  // If we were to AJAXify, we'd showLoading() before the AJAX call.
  // For full page reloads via these links, the browser's native loading indication is primary.
  // However, if we want consistency with form submissions:
  $(document).on("click", ".pagination-link", function (e) {
    // Check if it's a link within our pagination controls to avoid affecting other links
    if ($(this).closest(".pagination-controls").length) {
      showLoading();
    }
  });

  // Ensure other filters also submit this main form and show loading
  $("#search-tribes").on("keypress", function (e) {
    if (e.which === 13) {
      // Enter key
      e.preventDefault();
      form.find("#tribe-page-field").val(1); // Reset to page 1 on new search
      // showLoading(); // Form submit event will handle this
      form.submit();
    }
  });

  $("#state-filter, #editor-filter").on("change", function () {
    form.find("#tribe-page-field").val(1); // Reset to page 1 on filter change
    // showLoading(); // Form submit event will handle this
    form.submit();
  });

  // 'Clear Filters' button click
  $("#clear-tribe-filters").on("click", function () {
    form.find("#search-tribes").val("");
    form.find("#state-filter").val(null).trigger("change.select2"); // Clear Select2 and trigger its change event
    form.find("#editor-filter").val(null).trigger("change.select2");
    form.find("#tribe-page-field").val(1); // Reset to page 1
    // Optionally reset sort and per_page, or keep them
    // form.find('#tribe-sort-field').val('name'); // Example: reset sort to default name
    // form.find('#tribe-sort-dir').val('asc');
    // form.find('#per-page-select').val(50).trigger('change'); // if you want to reset per_page too
    form.submit();
  });

  // The existing clickable-header logic in admin_sorting.js should target this form
  // by ensuring it finds a form that contains the sort fields `tribe-sort-field` and `tribe-sort-dir`.
  // The `admin_sorting.js` was already updated to use $(this).closest('form') or ID-based form finding.
  // As long as `tribe-sort-field` etc. are inside `tribes-filter-sort-pagination-form`, it should work.
  // For sort header clicks (handled by admin_sorting.js)
  // If admin_sorting.js submits this same form, its submit event will trigger showLoading().
});
